import type { BuildIdentity } from '@hopdrive/sdk-app-updater/react';
import { CLIENT_VERSION } from '../../clientVersion';

declare const __APP_UPDATER_BUILD_ID__: string;

/**
 * The bundle this tab is running. The Vite plugin bakes the build id (the same
 * commit as `<meta name="build-commit">`) and writes it to `version.json`; a tab
 * whose id differs from the deployed manifest has an update waiting. Outside a
 * Vite build (Jest) the id is `dev`.
 */
export const DEALER_BUNDLE: BuildIdentity = {
  buildId: typeof __APP_UPDATER_BUILD_ID__ === 'string' ? __APP_UPDATER_BUILD_ID__ : 'dev',
  clientVersion: CLIENT_VERSION,
};

/**
 * Local dev and PR previews poll every 15 seconds and log each decision to the
 * console, so a deploy shows up while someone is watching, and give an urgent
 * update a 60 second deadline and a 30 second "Keep editing" window so the
 * urgent path can be tried by hand. Test, demo and prod keep the package's
 * five-minute poll and deadline and two-minute window, and stay quiet.
 */
export function updaterDevAids(
  appEnv: string | undefined,
): { pollIntervalMs?: number; debug?: boolean; urgentDeadlineMs?: number; keepEditingMs?: number } {
  return appEnv === 'local' || appEnv === 'preview'
    ? { pollIntervalMs: 15_000, debug: true, urgentDeadlineMs: 60_000, keepEditingMs: 30_000 }
    : {};
}
